<mat-expansion-panel
  [formGroup]="datosPersonalesForm"
  hideToggle
  [expanded]="!flujo.ok && !flujo.cargando"
>
  <mat-expansion-panel-header>
    <mat-panel-title> Datos Personales </mat-panel-title>
    <mat-panel-description>
      <div *ngIf="(!flujo.ok && !flujo.cargando) && showCantidadCampos">
        <!--======informacion menu ======-->
        Completa sólo
        {{ calculaCantidadALlenar }}
        datos
      </div>
      <div *ngIf="flujo.cargando">
        <div class="spinner-border text-light" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div *ngIf="flujo.ok && !flujo.cargando">
        <!--======ok menu ======-->
        <img src="assets/icons/icon-check.svg" alt="ok" />
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <app-messages *ngIf="showInfoMessage" class="informativo mt-16 mb-16 p-16" message="Enviaremos a tu nombre el equipo, no olvides estar presente al momento de la entrega."></app-messages>
  <ng-container *ngIf="!flujo.cargando && flujo.mostrar">
    <div class="row">
      <div class="col-md-6 mt-36">
        <label for="nombre">Nombre</label>
        <input
          appCaracteres
          [readonly]="
            (datosPersonalesResponse?.nombre.nombres || '') !== ''
          "
          type="text"
          name="nombre"
          formControlName="nombre"
          placeholder="Ingresa nombre"
          autocomplete="off"
          appMaxLength="50"
          [class.inputInvalido]="
            datosPersonalesForm.get('nombre').invalid &&
            datosPersonalesForm.get('nombre').touched
          "
          required
        />
        <p
          *ngIf="
            (datosPersonalesForm.get('nombre').touched &&
              datosPersonalesForm.get('nombre') === null) ||
            (datosPersonalesForm.get('nombre').touched &&
              datosPersonalesForm.get('nombre').invalid)
          "
          class="mensajeError"
        >
          {{ mensajeErrorDatosPersonales.REQUIRED_NAME_MESSAGE }}
        </p>
      </div>
      <div class="col-md-6 mt-36">
        <label for="primerApellido">Primer apellido</label>
        <input
          appCaracteres
          [readonly]="
            (datosPersonalesResponse?.nombre.apellidoPaterno || '') !== ''
          "
          type="text"
          name="primerApellido"
          formControlName="primerApellido"
          placeholder="Ingresa primer apellido"
          autocomplete="off"
          appMaxLength="50"
          [class.inputInvalido]="
            datosPersonalesForm.get('primerApellido').invalid &&
            datosPersonalesForm.get('primerApellido').touched
          "
          required
        />
        <p
          *ngIf="
            (datosPersonalesForm.get('primerApellido').touched &&
              datosPersonalesForm.get('primerApellido') === null) ||
            (datosPersonalesForm.get('primerApellido').touched &&
              datosPersonalesForm.get('primerApellido').invalid)
          "
          class="mensajeError"
        >
          {{ mensajeErrorDatosPersonales.REQUIRED_LASTNAME_MESSAGE }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mt-36">
        <label for="segundoApellido">Segundo apellido (opcional)</label>
        <input
          appCaracteres
          [readonly]="
            (datosPersonalesResponse?.nombre.apellidoMaterno || '') !== ''
          "
          type="text"
          name="segundoApellido"
          formControlName="segundoApellido"
          placeholder="Ingresa segundo apellido"
          appMaxLength="50"
          autocomplete="off"
        />
      </div>
      <!-- Existen dos DIV de nacionalidad ya que el disabled lógico no lo detecta -->
      <div class="col-md-6 mt-36">
        <label for="nacionalidad">Nacionalidad</label>
        <ng-container *ngIf="datosPersonalesResponse?.idNacionalidad === 47; else selectHabilitado">
          <select name="nacionalidad" formControlName="nacionalidad" disabled>
            <option *ngFor="let nacionalidad of nacionalidades" [value]="nacionalidad.id">
              {{ nacionalidad.nombre }}
            </option>
          </select>
        </ng-container>
        <ng-template #selectHabilitado>
          <select name="nacionalidad" formControlName="nacionalidad"
            [class.selectInvalido]="datosPersonalesForm.get('nacionalidad').invalid && datosPersonalesForm.get('nacionalidad').touched"
            placeholder="Seleccionar">
            <option value="0">Seleccionar</option>
            <option *ngFor="let nacionalidad of nacionalidades" [value]="nacionalidad.id">
              {{ nacionalidad.nombre }}
            </option>
          </select>
        </ng-template>
        <p
          *ngIf="
            (datosPersonalesForm.get('nacionalidad').touched &&
              datosPersonalesForm.get('nacionalidad') === null) ||
            (datosPersonalesForm.get('nacionalidad').touched &&
              datosPersonalesForm.get('nacionalidad').invalid)
          "
          class="mensajeError"
        >
          {{ mensajeErrorDatosPersonales.REQUIRED_COUNTRY_MESSAGE }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mt-36">
        <label for="correoElectronico">Correo electrónico</label>
        <input
          type="text"
          name="correoElectronico"
          formControlName="correoElectronico"
          placeholder="contacto@gmail.com"
          autocomplete="off"
          appMaxLength="40"
          [class.inputInvalido]="
            datosPersonalesForm.get('correoElectronico').invalid &&
            datosPersonalesForm.get('correoElectronico').touched
          "
          required
        />
        <p
          *ngIf="
            (datosPersonalesForm.get('correoElectronico').touched &&
              datosPersonalesForm.get('correoElectronico') === null) ||
            (datosPersonalesForm.get('correoElectronico').touched &&
              datosPersonalesForm.get('correoElectronico').invalid)
          "
          class="mensajeError"
        >
          {{ mensajeErrorDatosPersonales.REQUIRED_EMAIL_MESSAGE }}
        </p>
      </div>
      <div class="col-md-6 mt-36">
        <label for="telefono">Teléfono</label>
        <span class="prefijo">+56</span>
        <input
          appNumeros
          type="text"
          class="pre-input"
          name="telefono"
          formControlName="telefono"
          placeholder="Ingresar hasta 9 digitos"
          autocomplete="off"
          appMaxLength="9"
          [class.inputInvalido]="
            datosPersonalesForm.get('telefono').invalid &&
            (datosPersonalesForm.get('telefono').touched || datosPersonalesForm.get('telefono').dirty)
          "
          required
        />
        <p
          *ngIf="
            (datosPersonalesForm.get('telefono').touched || datosPersonalesForm.get('telefono').dirty) &&
            ( datosPersonalesForm.get('telefono').hasError('length') || datosPersonalesForm.get('telefono').hasError('pattern') )
          "
          class="mensajeError"
        >
          {{ mensajeErrorDatosPersonales.INVALID_PHONE_MESSAGE }}
        </p>
        <p
          *ngIf="
            (datosPersonalesForm.get('telefono').touched || datosPersonalesForm.get('telefono').dirty) &&
            datosPersonalesForm.get('telefono').hasError('required')
          "
          class="mensajeError"
        >
          {{ mensajeErrorDatosPersonales.REQUIRED_PHONE_MESSAGE }}
        </p>
      </div>
    </div>
    <!--<app-messages class="informativo" message="Tienes que validar tu Correo electrónico. Presiona Validar para seguir con el proceso."></app-messages>-->
    <div class="row box-button">
      <div class="col-md-12">
        <button
          class="btn-primary-tbk"
          type="submit"
          value="Continuar"
          (click)="Continuar($event)"
          [disabled]="!datosPersonalesForm.valid && !formChanged"
        >
          <div *ngIf="loading" class="spinner-border text-light" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div *ngIf="!loading">Guardar</div>
        </button>
      </div>
    </div>
  </ng-container>
</mat-expansion-panel>
